// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
